import React, { useEffect, useState } from 'react';
const buyers = [{
  n: 'Elena R.',
  c: 'Miami, FL'
}, {
  n: 'Andrés M.',
  c: 'Los Angeles, CA'
}, {
  n: 'Ricardo G.',
  c: 'Houston, TX'
}, {
  n: 'Sofía T.',
  c: 'New York, NY'
}, {
  n: 'Javier L.',
  c: 'Chicago, IL'
}, {
  n: 'Mateo S.',
  c: 'Dallas, TX'
}, {
  n: 'Valentina P.',
  c: 'San Antonio, TX'
}, {
  n: 'Diego C.',
  c: 'Phoenix, AZ'
}, {
  n: 'Isabella V.',
  c: 'San Diego, CA'
}, {
  n: 'Carlos B.',
  c: 'Orlando, FL'
}, {
  n: 'Lucía D.',
  c: 'Las Vegas, NV'
}, {
  n: 'Hernán J.',
  c: 'Denver, CO'
}, {
  n: 'Gabriela F.',
  c: 'Atlanta, GA'
}, {
  n: 'Roberto K.',
  c: 'San Francisco, CA'
}, {
  n: 'Paola M.',
  c: 'Austin, TX'
}, {
  n: 'Fernando S.',
  c: 'Tampa, FL'
}, {
  n: 'Claudia H.',
  c: 'Sacramento, CA'
}, {
  n: 'Ignacio R.',
  c: 'Portland, OR'
}, {
  n: 'Mónica P.',
  c: 'Seattle, WA'
}, {
  n: 'Alejandro Z.',
  c: 'Philadelphia, PA'
}, {
  n: 'Beatriz N.',
  c: 'Miami, FL'
}];
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showNotification = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setBuyer(randomBuyer);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    // First notification after 15 seconds
    const initialTimeout = setTimeout(showNotification, 15000);
    // Then every 30 seconds
    const interval = setInterval(showNotification, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div role="status" aria-live="polite" className={`fixed top-4 left-4 right-4 sm:right-auto sm:left-5 sm:top-5 z-[10000] bg-dark/95 border border-gold/30 px-4 py-3 sm:px-5 sm:py-4 rounded-lg shadow-[0_10px_30px_rgba(0,0,0,0.5)] max-w-[340px] sm:max-w-none transition-all duration-500 ease-out transform ${visible ? 'translate-y-0 opacity-100' : '-translate-y-[150px] opacity-0 pointer-events-none'}`} data-id="element-704">
      <div className="flex items-center gap-3" data-id="element-705">
        <span className="text-xl" aria-hidden="true" data-id="element-706">
          💰
        </span>
        <div className="text-[11px] leading-[1.4]" data-id="element-707">
          <span className="font-extrabold text-gold" data-id="element-708">{buyer.n}</span>
          <span className="text-white" data-id="element-709"> de </span>
          <span className="text-white" data-id="element-710">{buyer.c}</span>
          <br data-id="element-711" />
          <span className="text-white/75 text-[10px] uppercase tracking-[1px]" data-id="element-712">
            Acaba de activar el Código 888
          </span>
        </div>
      </div>
    </div>;
}